// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
  background-color: #0c111f;
  color: #b5bbcb;
  padding: 40px 80px;
  font-family: "Bricolage Grotesque", sans-serif;
  position: relative;
}

.footer-topRow {
  display: grid;  
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.footer-heading {
  font-size: 16px;
  font-weight: bold;
  color: #00e676;
  margin-bottom: 10px;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column li,
.footer-column p {
  font-size: 14px;
  margin-bottom: 6px;
}

.footer-middleRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px 0;
}

.footer-logo-img {
  width: 200px;
  max-width: 100%;
  height: auto;
}

.certifications-wrapper {
  text-align: center;
  margin-bottom: 20px;
}

.certifications-heading {
  font-size: 18px;
  font-weight: bold;
  color: #00e676;
  margin-bottom: 12px;
}

.cert-boxes {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  justify-content: center;
}

.cert-card {
  padding: 8px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.cert-img {
  width: 110px;
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.social-icons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #1c2331;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 16px;
}

.footer-bottom {
  text-align: center;
  padding-top: 10px;
  font-size: 14px;
  border-top: 1px solid #1f2937;
}

.qr-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.qr-float {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #fff;
  padding: 5px;
  border-radius: 10px;
  width: 120px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  text-align: center;
  z-index: 1000;
}

.qr-float img {
  width: 100px;
  height: 90px;
  border-radius: 8px;
  margin-bottom: 6px;
}

.qr-float p {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  margin: 0;
}

/* Responsive Styles */
@media (max-width: 1200px) {
  .footer-topRow {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .footer-topRow {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-container {
    padding: 40px 30px;
  }

  .footer-middleRow {
    flex-direction: column;
    text-align: center;
  }

  /* .qr-float {
    bottom: 15px;
    right: 15px;
  } */
}
@media (max-width: 768px) {
  .qr-float {
    width: auto;
    padding: 6px 8px;
    bottom: 15px;
    right: 15px;
    text-align: center;
  }

  .qr-float img {
    display: block;       /* show the QR */
    width: 70px;
    height: 70px;
    margin: 0 auto 4px;
    object-fit: contain;
  }

  .qr-float p {
    margin: 0;
    font-size: 12px;
    white-space: nowrap;
  }
}
@media (max-width: 576px) {

    .qr-float img {
    width: 60px;
    height: 60px;
  }
  .footer-topRow {
    grid-template-columns: 1fr;
  }

  .cert-img {
    width: 100px;
  }

  .footer-logo-img {
    width: 160px;
  }

  .icon-circle {
    font-size: 14px;
    width: 28px;
    height: 28px;
  }
}


 
/* chat bot css */
.chat-float {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 9999;
}
 
/* Toggle Button */
.chat-toggle {
  padding: 10px ;
  background-color: #168114;
  color: rgb(250, 250, 251);
  border: none;
  border-radius: 20px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
}
 
/* Chat Box */
.chat-box {
  width: 320px;
  height: 460px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateX(-360px);
  opacity: 0;
  transition: transform 0.4s ease, opacity 0.4s ease;
}
 
/* Show Chat Box */
.chat-float.open .chat-box {
  transform: translateX(0);
  opacity: 1;
}
 
/* Header */
.chat-header {
  background: #0059b3;
  color: white;
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px 10px 0 0;
}
 
/* Body */
.chat-body {
  flex: 1 1;
  padding: 10px;
  overflow-y: auto;
  background: #f2f2f2;
}
 
/* Messages */
.chat-msg {
  margin: 8px 0;
  padding: 8px 12px;
  border-radius: 15px;
  max-width: 80%;
  line-height: 1.4;
  font-size: 14px;
}
 
.chat-msg.user {
  background: #54cb7b;
  color: white;
  margin-left: auto;
  text-align: right;
}
 
.chat-msg.bot {
  background: #4b54fd;
  color: white;
  text-align: left;
}
 
/* Input */
.chat-input {
  display: flex;
  padding: 10px;
  border-top: 1px solid #ccc;
}
 
.chat-input input {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
 
.chat-input button {
  margin-left: 5px;
  padding: 8px 12px;
  background-color: #0059b3;
  color: white;
  border: none;
  border-radius: 5px;
}
 
/* FAQ Buttons */
.chat-faqs {
  display: flex;
  flex-wrap: wrap;
  padding: 8px 10px;
  gap: 6px;
  border-top: 1px solid #ddd;
  background: #f9f9f9;
}
 
.chat-faqs button {
  padding: 5px 10px;
  font-size: 13px;
  background-color: #e0e7ff;
  border: 1px solid #c7d2fe;
  border-radius: 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
 
.chat-faqs button:hover {
  background-color: #c7d2fe;
}
 
@keyframes bounceInLeft {
  0% {
    opacity: 0;
    transform: translateX(-300px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
 
@keyframes bounceInUp {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
 
.bounce-in-left {
  animation: bounceInLeft 0.6s ease forwards;
}
 
.bounce-in-up {
  animation: bounceInUp 0.6s ease forwards;
}
 
/* FAQ Buttons */
.faq-buttons {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  gap: 8px;
  justify-content: center;
  background: #fff;
}
 
.faq-buttons button {
  padding: 6px 12px;
  background: #e6f0ff;
  border: 1px solid #0059b3;
  border-radius: 20px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.3s ease;
}
 
.faq-buttons button:hover {
  background: #d0e0ff;
}
 
 
.typing-indicator {
  font-style: italic;
  opacity: 0.7;
  animation: pulse 1s infinite;
}
 
@keyframes pulse {
  0% { opacity: 0.4; }
  50% { opacity: 1; }
  100% { opacity: 0.4; }
}
 
 
.typing-dots {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  height: 24px;
  padding-left: 8px;
}
 
.typing-dots span {
  width: 6px;
  height: 6px;
  background-color: #666;
  border-radius: 50%;
  animation: bounce 1.2s infinite ease-in-out both;
}
 
.typing-dots span:nth-child(1) {
  animation-delay: 0s;
}
.typing-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-dots span:nth-child(3) {
  animation-delay: 0.4s;
}
 
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
 
 /* Chevron icons */
.chevron-icon {
  display: none;
  margin-left: 8px;
  transition: transform 0.3s ease;
}

/* Footer content toggle */
.footer-content {
  display: block;
}

@media (max-width: 576px) {
  .chevron-icon {
    display: inline-block;
 float: right;
    cursor: pointer;
  }

  .footer-content {
    display: none;
    margin-top: 8px;
  }

  .footer-content.open {
    display: block;
  }
}
.qr-card {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #ffffff;
  padding: 15px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  text-align: center;
  cursor: pointer;
  z-index: 9999;
  transition: all 0.3s ease;
  animation: slideInRight 0.6s ease;
}

.qr-card:hover {
  transform: translateY(-5px) scale(1.05);
}

.qr-img {
  width: 140px;
  height: 120px;
  object-fit: contain;
}

.qr-text {
  margin-top: 10px;
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/FooterSection.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;;;KAGG;AACL;AACA;EACE;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,cAAc,QAAQ,gBAAgB;IACtC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;;IAEI;IACA,WAAW;IACX,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;AACF;;;;AAIA,iBAAiB;AACjB;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,6BAA6B;EAC7B,UAAU;EACV,kDAAkD;AACpD;;AAEA,kBAAkB;AAClB;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,SAAS;AACT;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,QAAQ;EACR,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,UAAU,EAAE;EAClB,OAAO,YAAY,EAAE;AACvB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;CAEC,kBAAkB;AACnB;EACE,aAAa;EACb,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE;IACE,qBAAqB;CACxB,YAAY;IACT,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".footer-container {\r\n  background-color: #0c111f;\r\n  color: #b5bbcb;\r\n  padding: 40px 80px;\r\n  font-family: \"Bricolage Grotesque\", sans-serif;\r\n  position: relative;\r\n}\r\n\r\n.footer-topRow {\r\n  display: grid;  \r\n  grid-template-columns: repeat(5, 1fr);\r\n  gap: 20px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.footer-heading {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  color: #00e676;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.footer-column ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.footer-column li,\r\n.footer-column p {\r\n  font-size: 14px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.footer-middleRow {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 20px;\r\n  padding: 20px 0;\r\n}\r\n\r\n.footer-logo-img {\r\n  width: 200px;\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.certifications-wrapper {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.certifications-heading {\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  color: #00e676;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.cert-boxes {\r\n  display: flex;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.cert-card {\r\n  padding: 8px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.cert-img {\r\n  width: 110px;\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 4px;\r\n}\r\n\r\n.social-icons {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.icon-circle {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  background-color: #1c2331;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #fff;\r\n  font-size: 16px;\r\n}\r\n\r\n.footer-bottom {\r\n  text-align: center;\r\n  padding-top: 10px;\r\n  font-size: 14px;\r\n  border-top: 1px solid #1f2937;\r\n}\r\n\r\n.qr-button {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.qr-float {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  background-color: #fff;\r\n  padding: 5px;\r\n  border-radius: 10px;\r\n  width: 120px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n  text-align: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.qr-float img {\r\n  width: 100px;\r\n  height: 90px;\r\n  border-radius: 8px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.qr-float p {\r\n  font-size: 14px;\r\n  color: #000;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n/* Responsive Styles */\r\n@media (max-width: 1200px) {\r\n  .footer-topRow {\r\n    grid-template-columns: repeat(3, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .footer-topRow {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .footer-container {\r\n    padding: 40px 30px;\r\n  }\r\n\r\n  .footer-middleRow {\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n\r\n  /* .qr-float {\r\n    bottom: 15px;\r\n    right: 15px;\r\n  } */\r\n}\r\n@media (max-width: 768px) {\r\n  .qr-float {\r\n    width: auto;\r\n    padding: 6px 8px;\r\n    bottom: 15px;\r\n    right: 15px;\r\n    text-align: center;\r\n  }\r\n\r\n  .qr-float img {\r\n    display: block;       /* show the QR */\r\n    width: 70px;\r\n    height: 70px;\r\n    margin: 0 auto 4px;\r\n    object-fit: contain;\r\n  }\r\n\r\n  .qr-float p {\r\n    margin: 0;\r\n    font-size: 12px;\r\n    white-space: nowrap;\r\n  }\r\n}\r\n@media (max-width: 576px) {\r\n\r\n    .qr-float img {\r\n    width: 60px;\r\n    height: 60px;\r\n  }\r\n  .footer-topRow {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .cert-img {\r\n    width: 100px;\r\n  }\r\n\r\n  .footer-logo-img {\r\n    width: 160px;\r\n  }\r\n\r\n  .icon-circle {\r\n    font-size: 14px;\r\n    width: 28px;\r\n    height: 28px;\r\n  }\r\n}\r\n\r\n\r\n \r\n/* chat bot css */\r\n.chat-float {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  left: 20px;\r\n  z-index: 9999;\r\n}\r\n \r\n/* Toggle Button */\r\n.chat-toggle {\r\n  padding: 10px ;\r\n  background-color: #168114;\r\n  color: rgb(250, 250, 251);\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n \r\n/* Chat Box */\r\n.chat-box {\r\n  width: 320px;\r\n  height: 460px;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 0 15px rgba(0,0,0,0.15);\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  transform: translateX(-360px);\r\n  opacity: 0;\r\n  transition: transform 0.4s ease, opacity 0.4s ease;\r\n}\r\n \r\n/* Show Chat Box */\r\n.chat-float.open .chat-box {\r\n  transform: translateX(0);\r\n  opacity: 1;\r\n}\r\n \r\n/* Header */\r\n.chat-header {\r\n  background: #0059b3;\r\n  color: white;\r\n  padding: 12px 15px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-radius: 10px 10px 0 0;\r\n}\r\n \r\n/* Body */\r\n.chat-body {\r\n  flex: 1;\r\n  padding: 10px;\r\n  overflow-y: auto;\r\n  background: #f2f2f2;\r\n}\r\n \r\n/* Messages */\r\n.chat-msg {\r\n  margin: 8px 0;\r\n  padding: 8px 12px;\r\n  border-radius: 15px;\r\n  max-width: 80%;\r\n  line-height: 1.4;\r\n  font-size: 14px;\r\n}\r\n \r\n.chat-msg.user {\r\n  background: #54cb7b;\r\n  color: white;\r\n  margin-left: auto;\r\n  text-align: right;\r\n}\r\n \r\n.chat-msg.bot {\r\n  background: #4b54fd;\r\n  color: white;\r\n  text-align: left;\r\n}\r\n \r\n/* Input */\r\n.chat-input {\r\n  display: flex;\r\n  padding: 10px;\r\n  border-top: 1px solid #ccc;\r\n}\r\n \r\n.chat-input input {\r\n  flex: 1;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 5px;\r\n}\r\n \r\n.chat-input button {\r\n  margin-left: 5px;\r\n  padding: 8px 12px;\r\n  background-color: #0059b3;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 5px;\r\n}\r\n \r\n/* FAQ Buttons */\r\n.chat-faqs {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: 8px 10px;\r\n  gap: 6px;\r\n  border-top: 1px solid #ddd;\r\n  background: #f9f9f9;\r\n}\r\n \r\n.chat-faqs button {\r\n  padding: 5px 10px;\r\n  font-size: 13px;\r\n  background-color: #e0e7ff;\r\n  border: 1px solid #c7d2fe;\r\n  border-radius: 15px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n \r\n.chat-faqs button:hover {\r\n  background-color: #c7d2fe;\r\n}\r\n \r\n@keyframes bounceInLeft {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateX(-300px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n \r\n@keyframes bounceInUp {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(100px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n \r\n.bounce-in-left {\r\n  animation: bounceInLeft 0.6s ease forwards;\r\n}\r\n \r\n.bounce-in-up {\r\n  animation: bounceInUp 0.6s ease forwards;\r\n}\r\n \r\n/* FAQ Buttons */\r\n.faq-buttons {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: 10px;\r\n  gap: 8px;\r\n  justify-content: center;\r\n  background: #fff;\r\n}\r\n \r\n.faq-buttons button {\r\n  padding: 6px 12px;\r\n  background: #e6f0ff;\r\n  border: 1px solid #0059b3;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n}\r\n \r\n.faq-buttons button:hover {\r\n  background: #d0e0ff;\r\n}\r\n \r\n \r\n.typing-indicator {\r\n  font-style: italic;\r\n  opacity: 0.7;\r\n  animation: pulse 1s infinite;\r\n}\r\n \r\n@keyframes pulse {\r\n  0% { opacity: 0.4; }\r\n  50% { opacity: 1; }\r\n  100% { opacity: 0.4; }\r\n}\r\n \r\n \r\n.typing-dots {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 5px;\r\n  height: 24px;\r\n  padding-left: 8px;\r\n}\r\n \r\n.typing-dots span {\r\n  width: 6px;\r\n  height: 6px;\r\n  background-color: #666;\r\n  border-radius: 50%;\r\n  animation: bounce 1.2s infinite ease-in-out both;\r\n}\r\n \r\n.typing-dots span:nth-child(1) {\r\n  animation-delay: 0s;\r\n}\r\n.typing-dots span:nth-child(2) {\r\n  animation-delay: 0.2s;\r\n}\r\n.typing-dots span:nth-child(3) {\r\n  animation-delay: 0.4s;\r\n}\r\n \r\n@keyframes bounce {\r\n  0%, 80%, 100% {\r\n    transform: scale(0);\r\n    opacity: 0.3;\r\n  }\r\n  40% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n \r\n /* Chevron icons */\r\n.chevron-icon {\r\n  display: none;\r\n  margin-left: 8px;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n/* Footer content toggle */\r\n.footer-content {\r\n  display: block;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .chevron-icon {\r\n    display: inline-block;\r\n float: right;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .footer-content {\r\n    display: none;\r\n    margin-top: 8px;\r\n  }\r\n\r\n  .footer-content.open {\r\n    display: block;\r\n  }\r\n}\r\n.qr-card {\r\n  position: fixed;\r\n  bottom: 30px;\r\n  right: 30px;\r\n  background: #ffffff;\r\n  padding: 15px;\r\n  border-radius: 16px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\r\n  text-align: center;\r\n  cursor: pointer;\r\n  z-index: 9999;\r\n  transition: all 0.3s ease;\r\n  animation: slideInRight 0.6s ease;\r\n}\r\n\r\n.qr-card:hover {\r\n  transform: translateY(-5px) scale(1.05);\r\n}\r\n\r\n.qr-img {\r\n  width: 140px;\r\n  height: 120px;\r\n  object-fit: contain;\r\n}\r\n\r\n.qr-text {\r\n  margin-top: 10px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #1e293b;\r\n}\r\n\r\n@keyframes slideInRight {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(50px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
